import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, QueryParameter, NotificationService } from 'yt-ng-framework';
import { KomitentObjekatUpisnoMesto } from './komitent-objekat-upisno-mesto';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
import { Komitent } from '../komitent/komitent';
import { List } from 'immutable';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-komitent-objekat-upisno-mesto-update',
  templateUrl: './komitent-objekat-upisno-mesto-update.component.html'
})
export class KomitentObjekatUpisnoMestoUpdateComponent
 extends BaseUpdateComponent<KomitentObjekatUpisnoMesto>
  implements OnInit {

  parameterList: List<QueryParameter> = List([]);
  KomitentID: QueryParameter = new QueryParameter();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(
      activatedRoute,
      baseDataService,
      toastrService,
      translateService
    );
  }

  ngOnInit() {
    this.KomitentID.Name = "komitentid";
    this.KomitentID.Value = -1;
    this.parameterList = this.parameterList.push(this.KomitentID);

    this.addValidatorToFc("KomitentObjekatID",Validators.required,"required","KOMITENTOBJEKATUPISNOMESTO.KOMITENTOBJEKAT.VALIDATION.REQUIRED");
    this.addValidatorToFc("NazivUpisnogMesta",Validators.required,"required","KOMITENTOBJEKATUPISNOMESTO.NAZIVUPISNOGMESTA.VALIDATION.REQUIRED");
    this.addValidatorToFc("NazivUpisnogMesta",Validators.maxLength(100),"maxlength","KOMITENTOBJEKATUPISNOMESTO.NAZIVUPISNOGMESTA.VALIDATION.MAXLENGHT");

    this.IDProcessed
    .subscribe((value)=>{
      if (value){        
        if (this.baseFormGroup.get('KomitentID').value!=null){
          this.KomitentID.Value=this.baseFormGroup.get('KomitentID').value;
          this.KomitentID.Name="komitentid";
          if (this.KomitentID.Value!=null){
            this.parameterList=List([]);
            this.parameterList = this.parameterList.push(this.KomitentID);
          }
        }
      }
        
    })
  }

  pamtiVrednostKomitentID: number;
  onKomitentSelect(value : Komitent){
    if (value){
      //this.VrstaDokumentaID.Value=value;
     //let parameterList: List<QueryParameter> = List([new QueryParameter('VrstaDokumentaID', value)]);
     // let parameterList: List<QueryParameter> = List([new QueryParameter(this.VrstaDokumentaID.Value)]);
     if(this.pamtiVrednostKomitentID && this.pamtiVrednostKomitentID!=value.ID){
      this.baseFormGroup.patchValue({KomitentObjekatID:null});
      this.baseFormGroup.get("KomitentObjekatID").updateValueAndValidity();
     }
      this.parameterList=List([]);
      this.KomitentID.Name="komitentid";
      this.KomitentID.Value=value.ID;
      this.parameterList = this.parameterList.push(this.KomitentID)
      this.TransferParameters = this.TransferParameters.set(0, this.parameterList);
      this.pamtiVrednostKomitentID=value.ID;

     
    }
  }


}
